import getSources from '@shoflo/studio-redux/actions/source/getSources';

export default () => {
  return dispatch => {
    dispatch(getSources());
  };
};
